import {isNil} from "lodash";
import {createSelector} from "reselect/lib/index";
import {
  BANK_STATUS,
  eligibleBankStatusesMap,
  VERIFICATION_STATUS,
} from "../../../settings/settings";
import {
  getBankAssociableWithIRAFunds,
  getBankAssociatedWithIRAFunds
} from "../UserFunds/userFunds.selectors";

export const getExistingBanksLoaded = (state) => state.existingBanks.isLoaded;

export const getExistingBanksLoading = (state) => state.existingBanks.isLoading;

export const getExistingBanksFailed = (state) => state.existingBanks.hasFailed;

export const getExistingBanksInfo = (state) => state.existingBanks.banks;
export const getAgreementMap = (state) =>
  state.associatedAgreements
    ? state.associatedAgreements.associatedAgreements
    : [];

export const isEligible = (bank, agreementMap) => {
  const mappedBank = agreementMap[bank.bankAgreementID];
  if (mappedBank) {
    // if we are able to match the bank we should check that is eligible to transaction upon
    return (
      mappedBank.associatedAgreements.length > 0 ||
      mappedBank.associableAgreements.length > 0
    );
  } else {
    // if we can't map a bank rely on backend's flag for verified or if is of an eligible status found in settings
    return (
      !bank.bankAwaitingVerification ||
      eligibleBankStatusesMap[bank.verificationStatus]
    );
  }
};

export const getExistingBanks = createSelector(
  getExistingBanksInfo,
  getAgreementMap,
  getBankAssociatedWithIRAFunds,
  getBankAssociableWithIRAFunds,
  (existingBanks, agreementMap, anyBankAssociatedWithIRAFunds, anyBankAssociableWithIRAFunds) =>
    existingBanks.length > 0 ?
    existingBanks
      .filter((bank) => isEligible(bank, agreementMap))
      .map((bank) => {
        const bankCopy = {
          ...bank,
          bankStatus: null,
        };

        if (!isNil(bank.hasRedemptionHold) && bank.hasRedemptionHold) {
          bankCopy.bankStatus = BANK_STATUS.PROCESSING;
        }
        if (
          bank.bankAwaitingVerification &&
          bank.verificationStatus &&
          bank.verificationStatus === VERIFICATION_STATUS.INITIATED
        ) {
          bankCopy.bankStatus = BANK_STATUS.PREPARING_MICRO_DEPOSITS;
        }
        if (
          bank.bankAwaitingVerification &&
          bank.verificationStatus &&
          bank.verificationStatus === VERIFICATION_STATUS.READY_FOR_VALIDATION
        ) {
          bankCopy.bankStatus = BANK_STATUS.VERIFY_MICRO_DEPOSITS;
        }
        if (bank.verificationStatus === VERIFICATION_STATUS.LAPSED) {
          bankCopy.bankStatus = BANK_STATUS.REQUIRES_RENEWAL;
        }
        if (bank.corruptBankData) {
          bankCopy.bankStatus = BANK_STATUS.CORRUPT_BANK_DATA;
        }
        if (
          bank.bankAwaitingVerification &&
          bank.verificationStatus &&
          bank.verificationStatus === VERIFICATION_STATUS.LAPSED
        ) {
          bankCopy.bankStatus = BANK_STATUS.LAPSED;
        }
        if (
          !bankCopy.bankStatus &&
          anyBankAssociableWithIRAFunds &&
          !anyBankAssociatedWithIRAFunds
        ) {
          bankCopy.bankStatus = BANK_STATUS.NOT_LINKED;
        }
        if (
          !bankCopy.bankStatus &&
          !anyBankAssociatedWithIRAFunds
        ) {
          bankCopy.bankStatus = BANK_STATUS.NOT_ASSOCIATED;
        }
        return bankCopy;
      })
      : []
);
